export const getAuthToken = () => localStorage.getItem("authToken");

export const removeAuthToken = () => localStorage.removeItem("authToken");
